import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink } from "react-router-dom";

const SidebarItem = ({ item }) => {
  // Si el item tiene submenu
  if (item.submenu && item.submenu.length > 0) {
    return (
      <li className="dropdown">
        <a href="#">
          <Icon icon={item.icon} className="menu-icon" />
          <span>{item.label}</span>
        </a>
        <ul className="sidebar-submenu">
          {item.submenu.map((subitem, index) => (
            <li key={index}>
              <NavLink
                to={subitem.to}
                className={({ isActive }) => (isActive ? "active-page" : "")}
              >
                <Icon icon={subitem.icon} className="menu-icon" />
                <span>{subitem.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </li>
    );
  }

  // Item normal sin submenu
  return (
    <li>
      <NavLink
        to={item.to}
        className={({ isActive }) => (isActive ? "active-page" : "")}
      >
        <Icon icon={item.icon} className="menu-icon" />
        <span>{item.label}</span>
      </NavLink>
    </li>
  );
};

export default SidebarItem;
